import React from 'react';
import { Box, RadioButton, Text } from '@common-fe/common-fe';

import { StepOption } from '../stores/useRenewalSetup.store';
import { RenewOptionCardWrapper } from '../styles/RenewalSetup.styles';

export interface Props {
  title: React.ReactNode;
  optionValue: StepOption;
  isChecked?: boolean;
  isDisabled?: boolean;
  onClick: (option: StepOption) => void;
}

const RenewOptionCard: React.FC<Props> = ({
  title = '',
  optionValue,
  isChecked,
  isDisabled,
  onClick,
}) => {
  return (
    <RenewOptionCardWrapper
      direction="row"
      justify="between"
      align="center"
      data-testid="renewal-radio-option-card"
      background="canvas"
      pad={{ vertical: 'm', horizontal: 'l' }}
      height="fit-content"
      round="container1Round"
      onClick={!isDisabled ? () => onClick(optionValue) : undefined}
      isChecked={isChecked}
      isDisabled={isDisabled}
    >
      <Box width={{ min: '32px' }} margin={{ right: 'xss' }} align="center" justify="center">
        <RadioButton
          name={optionValue}
          disabled={isDisabled}
          checked={isChecked}
        />
      </Box>
      <Box width="100%" gap="xxxs">
        <Text weight={700} size="16px" style={{ lineHeight: '20px'}} color={isDisabled ? 'textDisabled' : 'textBody'}>
          {title}
        </Text>
      </Box>
    </RenewOptionCardWrapper>
  );
};

export default RenewOptionCard;
